import React from 'react';

/**
 * Shows an image fully (no cropping, no distortion) using object-contain,
 * with a blurred copy of the same image filling the background so there
 * are no empty bars. Overlay content (badges, gradients) can be passed as children.
 */
const SmartImage = ({ src, alt = '', className = '', imgClass = '', fallbackText = 'Osho Universal', children }) => (
  <div className={`relative overflow-hidden bg-rose-soft ${className}`}>
    {src ? (
      <>
        <img
          src={src}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-50"
        />
        <img
          src={src}
          alt={alt}
          className={`absolute inset-0 w-full h-full object-contain ${imgClass}`}
        />
      </>
    ) : (
      <div className="absolute inset-0 flex items-center justify-center text-mahogany/40 font-serif-display text-xl">
        {fallbackText}
      </div>
    )}
    {children}
  </div>
);

export default SmartImage;
